import { HistoricScreen } from "../../screen/HistoricScreen";
import data from '../../core/mocks/historic/mockHistoricData.json';
import { useState } from "react";

const formatData = (data = []) => {
  const newData = [...new Set(data.map( item => item.createdAt))]
  .map( date => {
    const dateToReturn = { date };
    dateToReturn.users = data.map( item => {
      if(item.createdAt === date && item.title !== 'Data do atendimento: ') {
        return {
          assistanceId: item.assistanceId,
          questionId: item.questionId,
          questionTitle: item.title,
          isPublic: item.isPublic,
          userId: item.userId,
          userName: item.name,
          userEmail: item.email,
          value: item.value,
        }
      }
    }).filter(item => item?.assistanceId);

    return dateToReturn;
  })

  return newData;
}

const HistoricContainer = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const toggleModalIsOpen = (user) => {
    setSelectedUser(modalIsOpen ? null : user);
    setModalIsOpen(!modalIsOpen);
  }

  return <HistoricScreen
    data={formatData(data)}
    {...{modalIsOpen, toggleModalIsOpen, selectedUser}}
  />
}

export default HistoricContainer